/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconPlanet1 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M5.628 19.347C1.467 15.928.867 9.783 4.286 5.622S13.85.861 18.011 4.28c.445.365.856.77 1.229 1.208M21.567 11.586c.125 5.384-4.137 9.85-9.521 9.975a9.97 9.97 0 0 1-.599-.004" />
        <path d="M3.147 16.273c-1.934 3.015-2.684 5.443-1.742 6.386 1.631 1.631 7.712-1.807 13.583-7.677S24.3 3.03 22.665 1.4c-.939-.939-3.379-.171-6.377 1.745" />
        <path d="M12.945 5.814a1.874 1.874 0 1 1 .001 3.749 1.874 1.874 0 0 1-.001-3.749zM2.783 8.147a3.751 3.751 0 1 1 .788 7.417 4.239 4.239 0 0 1-.8-.107" />
      </g>
    </svg>
  ),
);
